import {
  useHttpClient,
  createAuthApi,
  createLocationApi,
  createEmployeeApi,
  createPractitionerApi,
  createPatientApi,
  createIntakeApi,
  createTreatmentApi,
  createNoteApi,
  createCalendarApi,
  createMessageApi,
  createTodoApi,
  createTrajectoryApi,
  createProductApi,
  createInsurerApi,
  createDeclarationApi,
  createPromApi,
  createGroupClassApi,
  createOrganizationApi,
  createPracticeApi,
  createSubscriptionApi,
  createReferralApi,
  createImportExportApi,
  createSettingsApi,
  createWorkScheduleApi,
  createExternalApi,
  createAnnouncementApi,
  createOnboardingApi,
  createZorgmailApi,
  createPatientDocumentApi,
  createZorgtopicsApi,
  createIntakeQuestionnaireApi,
} from "./api";

const useApi = async (showSentryCrashModalOnFailedRequest: boolean = true) => {
  const helpers = await useHttpClient(showSentryCrashModalOnFailedRequest);

  return {
    httpClient: helpers.httpClient,
    ...createAuthApi(helpers),
    ...createLocationApi(helpers),
    ...createEmployeeApi(helpers),
    ...createPractitionerApi(helpers),
    ...createPatientApi(helpers),
    ...createIntakeApi(helpers),
    ...createTreatmentApi(helpers),
    ...createNoteApi(helpers),
    ...createCalendarApi(helpers),
    ...createMessageApi(helpers),
    ...createTodoApi(helpers),
    ...createTrajectoryApi(helpers),
    ...createProductApi(helpers),
    ...createInsurerApi(helpers),
    ...createDeclarationApi(helpers),
    ...createPromApi(helpers),
    ...createGroupClassApi(helpers),
    ...createOrganizationApi(helpers),
    ...createPracticeApi(helpers),
    ...createSubscriptionApi(helpers),
    ...createReferralApi(helpers),
    ...createImportExportApi(helpers),
    ...createSettingsApi(helpers),
    ...createWorkScheduleApi(helpers),
    ...createExternalApi(helpers),
    ...createAnnouncementApi(helpers),
    ...createOnboardingApi(helpers),
    ...createZorgmailApi(helpers),
    ...createPatientDocumentApi(helpers),
    ...createZorgtopicsApi(helpers),
    ...createIntakeQuestionnaireApi(helpers),
  };
};

export default useApi;

export type UseApiReturn = Awaited<ReturnType<typeof useApi>>;

export { serializeBooleanForFormData } from "./api/usePatientApi";
